export default {
    departments: undefined,
    departmentsOptions: [],
    importOptions: [],
    loading: false,
    error: null,
    errorShow: false
}